import React from 'react';
import ReactECharts from 'echarts-for-react';
import { format, parseISO, startOfMonth } from 'date-fns';

const CashFlowIntelligence = ({ transactions }) => {
  const monthlyData = transactions.reduce((acc, t) => {
    const month = format(parseISO(t.date), 'MMM yy');
    if (!acc[month]) acc[month] = { income: 0, expense: 0 };
    if (t.type === 'Income') acc[month].income += Number(t.amount);
    else acc[month].expense += Number(t.amount);
    return acc;
  }, {});

  const labels = Object.keys(monthlyData).sort((a, b) => new Date(a) - new Date(b));
  
  const option = {
    tooltip: { trigger: 'axis', axisPointer: { type: 'cross' } },
    legend: { bottom: 0, icon: 'circle', textStyle: { fontWeight: 'bold', fontSize: 10 } },
    grid: { left: '3%', right: '4%', top: '10%', bottom: '15%', containLabel: true },
    xAxis: { type: 'category', data: labels, axisLine: { show: false } },
    yAxis: { type: 'value', axisLabel: { formatter: '${value}' }, splitLine: { lineStyle: { type: 'dashed' } } },
    series: [
      {
        name: 'Revenue',
        type: 'bar',
        data: labels.map(l => monthlyData[l].income),
        itemStyle: { color: '#4F46E5', borderRadius: [4, 4, 0, 0] }
      },
      {
        name: 'Expenses',
        type: 'bar',
        data: labels.map(l => monthlyData[l].expense),
        itemStyle: { color: '#EF4444', borderRadius: [4, 4, 0, 0] }
      },
      {
        name: 'Net Cash Flow',
        type: 'line',
        smooth: true,
        data: labels.map(l => monthlyData[l].income - monthlyData[l].expense),
        lineStyle: { width: 3, color: '#10B981' },
        itemStyle: { color: '#10B981' }
      }
    ]
  };

  return (
    <div className="bg-white p-6 rounded-3xl border border-gray-100 shadow-sm">
      <h3 className="text-xs font-black text-gray-400 uppercase tracking-widest mb-6">Cash Flow Intelligence</h3>
      <div className="h-[350px]">
        <ReactECharts option={option} style={{ height: '100%' }} />
      </div>
    </div>
  );
};

export default CashFlowIntelligence;